import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmFileComponent } from './sm-file.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SmErrorModule } from '../sm-error/sm-error.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';



@NgModule({
  declarations: [SmFileComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SmErrorModule, PdfViewerModule, PaginationModule],
  exports: [SmFileComponent]
})
export class SmFileModule { }
